import { useState, useEffect } from "react";
import Modal from "../../../components/Modal/Modal";

const toInput = (d) => (d ? d.replace(" ", "T").slice(0, 16) : "");

const DeadlineModal = ({ open, close, currentDate, save }) => {
  const [value, setValue] = useState(toInput(currentDate));

  useEffect(() => {
    setValue(toInput(currentDate));
  }, [currentDate, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    save(value ? value.replace("T", " ") + ":00" : null); // YYYY-MM-DD HH:mm:ss
  };

  return (
    <Modal open={open} close={close}>
      <h2>Yayın Tarihi Ayarla</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="datetime-local"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="modal-input"
          autoFocus
        />

        <div className="modal-buttons">
          <button type="submit" className="modal-add-button">
            Kaydet
          </button>
          <button type="button" className="modal-close-button" onClick={close}>
            İptal
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default DeadlineModal;
